import React from "react";

export const CalendarIcon = () =>
  <>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.4091 1.54545H13.6364V0H12.0909V1.54545H4.36364V0H2.81818V1.54545H2.04545C1.19545 1.54545 0.5 2.24091 0.5 3.09091V15.4545C0.5 16.3045 1.19545 17 2.04545 17H14.4091C15.2591 17 15.9545 16.3045 15.9545 15.4545V3.09091C15.9545 2.24091 15.2591 1.54545 14.4091 1.54545ZM14.4091 15.4545H2.04545V5.40909H14.4091V15.4545Z" fill="white"/>
    </svg>
  </>;
